import { makeAutoObservable } from 'mobx';
import { UIStore } from "../UIStore";
import { IValidatedPageLibrary } from './IValidatedPageLibrary';
import { TextInputLibrary } from './FormLibraries/TextInputLibrary';
import { CheckInputLibrary } from './FormLibraries/CheckInputLibrary';
import { StatementCategoryOperationEnum } from '../../models';

export class InfoPageLibrary implements IValidatedPageLibrary
{

	private uiState: UIStore;

	public OrganizationName: TextInputLibrary;
	public OrganizationInn: TextInputLibrary;
	public OrganizationKpp: TextInputLibrary;
	public OrganizationHeadFirstName: TextInputLibrary;
	public OrganizationHeadLastName: TextInputLibrary;
	public OrganizationHeadSecondName: TextInputLibrary;
	public OrganizationHeadSecondNameExists: CheckInputLibrary;
	public OrganizationHeadPosition: TextInputLibrary;
	public AgreementCheck: CheckInputLibrary;

	constructor(ui: UIStore)
	{
		this.uiState = ui;

		this.OrganizationName = new TextInputLibrary("^(?![^ёЁА-Яа-яA-Za-z0-9]{1}$).{1,1000}$", 1000, () => true);
		this.OrganizationInn = new TextInputLibrary("^[0-9]{10}$", 10, () => true,  this.CheckInn);
		this.OrganizationKpp = new TextInputLibrary("^[0-9]{9}$", 9, () => true);
		this.OrganizationHeadFirstName = new TextInputLibrary("^[ёЁа-яА-Я– -]{1,255}$", 255, () => true);
		this.OrganizationHeadLastName = new TextInputLibrary("^[ёЁа-яА-Я– -]{1,255}$", 255, () => true);
		this.OrganizationHeadPosition = new TextInputLibrary("^[ёЁ0-9а-яА-Я– -]{1,128}$", 128, () => true);
		this.OrganizationHeadSecondNameExists = new CheckInputLibrary(() => false);
		this.AgreementCheck = new CheckInputLibrary(() => true, (value: boolean | undefined) =>
		{
			if (value)
			{
				this.uiState.setDisabledTabs([]);
			}
			else
			{
				this.uiState.setDisabledTabs([3, 4]);
			}
		});
		this.OrganizationHeadSecondName = new TextInputLibrary("^[ёЁа-яА-Я– -]{1,255}$", 255, () => this.OrganizationHeadSecondNameExists.Value??true);

		makeAutoObservable(this,
			{
			}, { autoBind: true });
	}

	public setIsDisabled(isDisabled: boolean)
	{
		this.OrganizationName.setIsDisabled(isDisabled);
		this.OrganizationInn.setIsDisabled(isDisabled);
		this.OrganizationKpp.setIsDisabled(isDisabled);
		this.OrganizationHeadFirstName.setIsDisabled(isDisabled);
		this.OrganizationHeadLastName.setIsDisabled(isDisabled);
		this.OrganizationHeadSecondName.setIsDisabled(isDisabled);
		this.OrganizationHeadPosition.setIsDisabled(isDisabled);
		this.AgreementCheck.setIsDisabled(isDisabled);
	}

	CheckInn(value: string): boolean
	{
		if (value.length !== 10) return false;
		let arr = [2, 4, 10, 3, 5, 9, 4, 6, 8, 0];
		let sum: number = 0;
		arr
			.map<number>((val, ind) => { return val * Number(value.substr(ind, 1)) })
			.forEach((val) => sum += val);
		sum = sum % 11;
		if (sum > 9) sum = sum % 10;
		return sum === Number(value.substr(9, 1));
	}

	//	#region	IValidatedPageLibrary
	public ValidationMessage: string = "";
	setValidationMessage(value: string) { if (value === "") this.ValidationMessage = value; else this.ValidationMessage = "Введены не все данные"; }

	public IsValid: boolean = false;
	setIsValid(value: boolean) { this.IsValid = value; }

	public Validate(onlyCheck?: boolean)
	{
		this.setValidationMessage("");
		this.IsValid = true;

		if (this.uiState.IsDisabled) { return this.IsValid; }

		if (!this.OrganizationName.Validate(onlyCheck))
		{
			this.setValidationMessage("Введены не все данные");
			//this.setValidationMessage("Введите Организацию");
			this.IsValid = false;
		}

		if (!this.OrganizationInn.Validate(onlyCheck))
		{
			this.setValidationMessage("Введены не все данные");
			//this.setValidationMessage("Введите ИНН");
			this.IsValid = false;
		}

		if (!this.OrganizationKpp.Validate(onlyCheck))
		{
			this.setValidationMessage("Введены не все данные");
			//this.setValidationMessage("Введите КПП");
			this.IsValid = false;
		}

		if (!this.OrganizationHeadFirstName.Validate(onlyCheck))
		{
			this.setValidationMessage("Введены не все данные");
			//this.setValidationMessage("Введите Имя");
			this.IsValid = false;
		}

		if (!this.OrganizationHeadLastName.Validate(onlyCheck))
		{
			this.setValidationMessage("Введены не все данные");
			//this.setValidationMessage("Введите Фамилию");
			this.IsValid = false;
		}

		if (!this.OrganizationHeadSecondName.Validate(onlyCheck))
		{
			this.setValidationMessage("Введены не все данные");
			//this.setValidationMessage("Введите Отчество");
			this.IsValid = false;
		}

		if (!this.OrganizationHeadPosition.Validate(onlyCheck))
		{
			this.setValidationMessage("Введены не все данные");
			//this.setValidationMessage("Введите Должность");
			this.IsValid = false;
		}

		this.uiState.register.SelectedServiceCategories.forEach((val) =>
		{
			if (val.Operation === StatementCategoryOperationEnum.RemoveInformation) return;

			if (!val.Email.Validate(onlyCheck))
			{
				this.setValidationMessage("Введены не все данные");
			//this.setValidationMessage("Введите Email");
				this.IsValid = false;
			}

			if (!val.Phone.Validate(onlyCheck))
			{
				this.setValidationMessage("Введены не все данные");
			//this.setValidationMessage("Введите Телефон");
				this.IsValid = false;
			}

			if (!val.Web.Validate(onlyCheck))
			{
				this.setValidationMessage("Введены не все данные");
			//this.setValidationMessage("Введите адрес сайта");
				this.IsValid = false;
			}

		})

		if (!this.AgreementCheck.Validate(onlyCheck))
		{
			this.setValidationMessage("Введены не все данные");
			//this.setValidationMessage("Подтвердите согласие");
			this.IsValid = false;
		}

		return this.IsValid;

	}
	//	#endregion

}
